import React, { Fragment, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams, Link } from "react-router-dom";
import { DocumentDownloadIcon, PlusIcon } from "@heroicons/react/solid";
import { API_URL } from "../redux/constants";
import readXlsxFile from "read-excel-file";
import { UserActions } from "../redux/UserActions";
import { editProfile, kickUsers, registerUser } from "../redux/UserActions";
import UserRegister from "./User/UserRegisterForm";

export default function ActiveUsers() {
  const dispatch = useDispatch();
  const userSelector = useSelector((state) => state.user);
  const { status } = useParams();
  const [showAddUserModal, setShowAddUserModal] = useState(false);

  const [rows, setRows] = useState([]);

  useEffect(() => {
    setRows(userSelector.users.filter((user) => user.status == status));
  }, [userSelector.users]);

  useEffect(() => {
    dispatch(UserActions.organization({}));
    dispatch(UserActions.users({}));
  }, [status]);

  useEffect(() => {
    dispatch(UserActions.organization({}));
    dispatch(UserActions.users({}));
  }, []);

  return (
    <div className="w-full h-screen flex flex-col">
      <div className="w-full py-2 flex flex-wrap items-center px-4 bg-gray-100 gap-x-3">
        <label className="text-2xl font-semibold text-center">
          {status.charAt(0).toUpperCase() + status.slice(1) + " Users"}
        </label>
        <input
          type="text"
          className="flex-grow border border-blue-200 rounded-xl"
          placeholder="Filter Users by Name/Email/Department/Location"
        />
        <PlusIcon
          className="flex h-6 w-6 cursor-pointer"
          onClick={() => {
            setShowAddUserModal(true);
          }}
        />
        <ImportUsers />
      </div>
      {rows.length > 0 && (
        <div className="w-full h-full p-2 gap-y-1 overflow-y-auto flex flex-col">
          {rows.map((row) => (
            <UserCard user={row} />
          ))}
        </div>
      )}
      {rows.length === 0 && (
        <label className=" w-full h-full text-center font-bold self-center text-black text-2xl ">
          No Users Here
        </label>
      )}
      <UserRegister
        isOpen={showAddUserModal}
        setIsOpen={setShowAddUserModal}
        // _handleRegister={(e) => regUser(e)}
      />
    </div>
  );
}

function UserCard({ user }) {
  const dispatch = useDispatch();

  const [archiveClicked, setArchiveClicked] = useState(false);
  return (
    <div className="flex flex-wrap justify-between gap-x-2 bg-gray-100 rounded-md p-2">
      <img
        className="h-10 w-10 rounded-full object-cover"
        src={
          user.profilePicture
            ? API_URL + "image/profile/" + String(user._id.$oid)
            : "https://t4.ftcdn.net/jpg/00/64/67/63/360_F_64676383_LdbmhiNM6Ypzb3FM4PPuFP9rHe7ri8Ju.jpg"
        }
        alt=""
      />
      <Link
        className="flex flex-col px-2 w-48 cursor-pointer h-full"
        to={"/users/" + String(user?._id?.$oid)}
      >
        <label className="text-xs text-gray-600 pointer-events-none ">
          Name:
        </label>
        <label className="font-semibold text-md pointer-events-none">{`${user.firstName} ${user.lastName}`}</label>
      </Link>
      <CardField
        label="Phone Number:"
        value={
          user.phone.number
            ? `${user.phone.code || ""} ${user.phone.number}`
            : "No Phone"
        }
      />
      <CardField label="Position:" value={user.position} />
      <CardField label="Department:" value={user.department} />
      <CardField label="Location:" value={user.location} />
      <CardField label="Role:" value={user.role} />
      <CardField
        label="Activity:"
        value={user.active}
        valueClass={
          (user.active === "No Activity" &&
            "rounded-lg text-white bg-red-400 text-center") ||
          (user.active === "Low Activity" &&
            "rounded-lg text-white bg-orange-400 text-center") ||
          (user.active === "Medium Activity Activity" &&
            "rounded-lg text-white bg-yellow-400 text-center") ||
          (user.active === "High Activity" &&
            "rounded-lg text-white bg-green-400 text-center") ||
          (user.active === "Daily Activity" &&
            "rounded-lg text-white bg-green-600 text-center") ||
          (user.active === "Not measured" &&
            "rounded-lg text-black text-center")
        }
      />
      <span className="flex gap-x-2">
        <input
          type="button"
          value="Reset Password"
          className="bg-indigo-600 rounded-lg p-2 text-white"
        />
        {!archiveClicked && (
          <input
            type="button"
            value={user.status === "active" ? "Archive User" : "Restore User"}
            className={
              "rounded-lg p-2 text-white " +
              (user.status === "active" ? "bg-red-600" : "bg-green-600")
            }
            onClick={() => setArchiveClicked(true)}
          />
        )}
        {archiveClicked && (
          <input
            type="button"
            value="Confirm"
            className={
              "rounded-lg p-2 text-white " +
              (user.status === "active" ? "bg-red-600" : "bg-green-600")
            }
            onClick={() => {
              dispatch(
                UserActions.archiveUser({ user: String(user._id.$oid) })
              );
              window.location.reload();
              // dispatch(UserActions.users({}));
            }}
          />
        )}
      </span>
    </div>
  );
}

function CardField({ label, value, valueClass }) {
  return (
    <span className="flex flex-col px-2 w-36">
      <label className="text-xs text-gray-600 ">{label}</label>
      <label className={"font-semibold text-md p-1 " + valueClass}>
        {value}
      </label>
    </span>
  );
}

function ImportUsers(props) {
  const dispatch = useDispatch();
  const [downloaded, setDownloaded] = useState(false);

  function registerMany() {
    const input = document.getElementById("fileInput");
    readXlsxFile(input.files[0]).then((rows) => {
      rows.map((rw, idx) => {
        if (idx !== 0 && idx !== 1 && idx !== 2) {
          dispatch(
            registerUser({
              firstName: rw[0],
              lastName: rw[1],
              mail: rw[2],
            })
          );
        }
      });
    });
  }

  return (
    <>
      {downloaded ? (
        <input
          id="fileInput"
          className="w-24"
          placeholder="FILE"
          type="file"
          onChange={(e) => registerMany()}
        />
      ) : (
        <a
          className="flex-initial m-2 mx-2"
          href="//static.wellm8.com/templates/Template.xlsx"
          download={true}
        >
          <DocumentDownloadIcon
            className="flex h-6 w-6 text-green-400"
            onClick={() => setDownloaded(true)}
            title="Test"
          />
        </a>
      )}
    </>
  );
}

function ManagementHeader({ children }) {
  return (
    <div className="grid grid-cols-7 h-14 p-1 bg-gray-200">{children}</div>
  );
}

function HeaderText({ defaultValue, placeholder, handle, children }) {
  return (
    <input
      type="text"
      defaultValue={defaultValue || ""}
      placeholder={placeholder || ""}
      className=""
      onChange={(e) => {
        handle(e.target.value);
      }}
    />
  );
}
